type URLSearchParamsArgs = ConstructorParameters<typeof URLSearchParams>;

type UrlSegment =
    | 'href'
    | 'fullDomain'
    | 'protocol'
    | 'host'
    | 'hostname'
    | ''
    | 'port'
    | 'pathname'
    | 'folderPath'
    | 'file'
    | 'fileName'
    | 'extension'
    | 'fileType'
    | 'search'
    | 'query'
    | 'hash'
    | 'anchor';

type ParsedUrl = {
    [US in UrlSegment]: string;
};

const URL_REG_EXP =
    /^(([^:\\\/]+:)\/\/(([^:\\\/]*)(:(\d+))?)?)?(([^\?#]*[\\\/])?(([^\\\/\?#]*?)(\.([^\.\?#]+))?))(\?([^#]*))?(#(.*))?$/;

const URL_SEGMENTS = [
    'href',
    'fullDomain',
    'protocol',
    'host',
    'hostname',
    '',
    'port',
    'pathname',
    'folderPath',
    'file',
    'fileName',
    'extension',
    'fileType',
    'search',
    'query',
    'hash',
    'anchor',
] as UrlSegment[];

// TODO: Generalize this to support other use-cases from problematic `url-lib` npm package
// we depended on that breaks our build currently
export function formatUrl(
    urlPath: string,
    urlParams?: URLSearchParamsArgs[0],
    baseUrl = 'https://www.eventbrite.com',
) {
    // NOTE: URL() requires a base but it's not relevant nor used in this code. This could
    // be anything.
    const url = new URL(urlPath, baseUrl);
    const params = new URLSearchParams(urlParams);
    url.search = params.toString();
    return url.pathname + url.search;
}

export function parseUrl(url?: string | null): ParsedUrl {
    const urlSegmentsMatch = url && url.match(URL_REG_EXP);

    const getUrlSegment = (segmentNo: number): string =>
        urlSegmentsMatch ? urlSegmentsMatch[segmentNo] || '' : '';

    return URL_SEGMENTS.reduce((prevParsedUrl, segmentName, segmentNo) => {
        const parsedUrl = prevParsedUrl;

        if (segmentName) {
            parsedUrl[segmentName] = getUrlSegment(segmentNo);
        }

        return parsedUrl;
    }, {} as ParsedUrl);
}
